import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "submit"]
  static values = {
    phrase: String,
    url: String,
  }

  declare readonly dialogTarget: HTMLDialogElement
  declare readonly inputTarget: HTMLInputElement
  declare readonly submitTarget: HTMLButtonElement
  declare readonly phraseValue: string
  declare readonly urlValue: string

  open(event: Event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.submitTarget.disabled = true
    this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  validate() {
    this.submitTarget.disabled = this.inputTarget.value !== this.phraseValue
  }

  confirm() {
    if (this.inputTarget.value !== this.phraseValue) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.urlValue

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = "delete"

    const csrfInput = document.createElement("input")
    csrfInput.type = "hidden"
    csrfInput.name = "authenticity_token"
    csrfInput.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || ""

    form.appendChild(methodInput)
    form.appendChild(csrfInput)
    document.body.appendChild(form)
    form.requestSubmit()
  }

  close() {
    this.dialogTarget.close()
  }
}
